import Cookies from 'js-cookie'
import 'regenerator-runtime/runtime'
import Prismic from 'prismic-javascript'
import {
    Environment,
    // Network,
    RecordSource,
    Store,
    QueryResponseCache,
} from 'relay-runtime'
import {
    RelayNetworkLayer,
    urlMiddleware,
    loggerMiddleware,
    errorMiddleware,
    perfMiddleware,
    retryMiddleware,
    authMiddleware,
} from 'react-relay-network-modern'

const store = new Store(new RecordSource())

const cache = new QueryResponseCache({ size: 100, ttl: 2 * 60 * 1000 })
const storedCache = window.localStorage.getItem('cache')
const serializedCache = JSON.parse(storedCache)
if (serializedCache) {
    for (let k of Object.keys(serializedCache)) {
        cache._responses.set(k, serializedCache[k])
    }
}

const network = new RelayNetworkLayer(
    [
        urlMiddleware({
            url: req => Promise.resolve(process.env.REACT_APP_GRAPHQL_ENDPOINT),
        }),
        process.env.NODE_ENV === 'development' || window.location.pathname === "/amp-builder" ? loggerMiddleware() : null,
        process.env.NODE_ENV === 'development' || window.location.pathname === "/amp-builder" ? errorMiddleware() : null,
        process.env.NODE_ENV === 'development' || window.location.pathname === "/amp-builder" ? perfMiddleware() : null,
        retryMiddleware({
            fetchTimeout: 15000,
            retryDelays: attempt => Math.pow(2, attempt + 4) * 100,
            forceRetry: (cb, delay) => {
                window.forceRelayRetry = cb
                console.log('call `forceRelayRetry()` for immediately retry! Or wait ' + delay + ' ms.')
            },
            statusCodes: [500, 503, 504],
        }),
        authMiddleware({
            token: () => localStorage.getItem('access_token'),
            tokenRefreshPromise: req => {
                console.log('[client.js] resolve token refresh', req)
            },
        }),
        next => async req => {
            const apiEndpoint = 'https://startupguide.prismic.io/api/v2'
            const api = await Prismic.api(apiEndpoint)

            const previewRef = Cookies.get(Prismic.previewCookie)
            const masterRef = api.refs.find(ref => { return ref.isMasterRef === true }).ref
            const ref = previewRef || masterRef
            req.fetchOpts.headers['X-Prismic'] = ref

            const cachedData = cache.get(req.id, Object.assign({ ref }, req.variables))
            if (cachedData) {
                console.log("cachedData: " + cachedData)
                console.log(`cache hit for ${req.id}`)
                return cachedData
            }

            const res = await next(req)
            // console.log("No cachedData: "+res)

            if (window.location.pathname !== "/amp-builder") {
                cache.set(req.id, Object.assign({ ref }, req.variables), res)
                const objectCache = Array.from(cache._responses).reduce((obj, [key, value]) => (Object.assign(obj, { [key]: value })), {})
                const serializedCache = JSON.stringify(objectCache)
                window.localStorage.setItem('cache', serializedCache)

                console.log("Data is now cached")
            }

            return res
        },
    ]
)

const environment = new Environment({
    network,
    store,
})

export default environment
